
import React from 'react';
import MessageInput from './MessageInput';
import ReplyContext from './ReplyContext';
import { ChatMessage } from '@/types/chat';

interface ChatInputAreaProps {
  canSendMessage: boolean;
  newMessage: string;
  onMessageChange: (value: string) => void;
  onSendMessage: (e: React.FormEvent) => void;
  selectedGroup: any;
  isMobile?: boolean;
  replyingTo?: ChatMessage | null;
  onCancelReply?: () => void;
}

const ChatInputArea = ({ 
  canSendMessage, 
  newMessage, 
  onMessageChange, 
  onSendMessage, 
  selectedGroup, 
  isMobile = false,
  replyingTo,
  onCancelReply
}: ChatInputAreaProps) => {
  if (canSendMessage) {
    return (
      <div className="bg-gray-800">
        {replyingTo && onCancelReply && (
          <ReplyContext
            parentMessage={replyingTo}
            onCancel={onCancelReply}
          />
        )}
        <MessageInput
          value={newMessage}
          onChange={onMessageChange}
          onSubmit={onSendMessage}
          chatGroupId={selectedGroup.chat_id}
          placeholder={
            replyingTo
              ? "Reply to thread..."
              : `Message ${selectedGroup.chat_name}... (Use @ to mention users)`
          }
        />
      </div>
    );
  }

  return (
    <div className={`bg-gray-700/50 flex items-center justify-center py-4 ${isMobile ? 'px-2' : 'px-4'}`}>
      <p className={`text-center text-gray-400 ${isMobile ? 'text-xs' : 'text-sm'}`}>
        This is a read-only chat. Only the group creator can send messages.
      </p>
    </div>
  );
};

export default ChatInputArea;
